import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import { getUserRoleForBackend } from '../../../../shared/functions/UserRole/userRoleManagment.functions'
import { ConfirmReceiptRequest, ConfirmReceiptSuccessResponse } from './confirmReceipt.types'

export const confirmReceiptApi = async (request: ConfirmReceiptRequest): Promise<ConfirmReceiptSuccessResponse> => {
  const response = await configureRequest({
    url: `logistics-partner/orders/${request.orderId}/confirm-receipt`,
    method: 'POST',
    data: {
      location: request.location,
      photoUrls: request.photoUrls || [],
      notes: request.notes || null,
      verifiedWeightGrams: request.verifiedWeightGrams,
      verifiedDimensions: request.verifiedDimensions,
      specialHandlingNotes: request.specialHandlingNotes || null,
      conditionCheck: {
        allItemsReceived: request.conditionCheck.allItemsReceived,
        itemsMatch: request.conditionCheck.itemsMatch,
        damageNoted: request.conditionCheck.damageNoted,
        damageDescription: request.conditionCheck.damageDescription ?? null
      }
    },
    headers: {
      'X-User-Role': getUserRoleForBackend()
    }
  })

  return response as ConfirmReceiptSuccessResponse
}
